import { Button as AIMEButton } from "tot-loft-component-library";

import * as PRTNR from "./prtnr";

import styled from "@emotion/styled";
import { useState } from "react";
import { useDispatch } from "react-redux";
import { createCharity, updateCharity } from "./redux/slices/charitiesThunks";
import { uploadImage } from "./redux/slices/VendorsonhomeThunks";

export default function ModalAdminCharities({
  onClose,
  mode = "add",
  charityData = {},
}) {
  const isEdit = mode === "edit";

  const dispatch = useDispatch();
  const [hasSubmitted, setHasSubmitted] = useState(false);
  const [formData, setFormData] = useState({
    name: charityData.name || "",
    number: charityData.number || "",
    logo: charityData.logo || "",
    short_description: charityData.short_description || "",
    long_description: charityData.long_description || "",
    contact_number: charityData.contact_number || "",
    person_to_contact: charityData.person_to_contact || "",
    address: charityData.address || "",
    postal_code: charityData.postal_code || "",
  });

  const handler = async () => {
    setHasSubmitted(true);
    if (!formData.name || !formData.number || !formData.contact_number) {
      return;
    }
    try {
      if (isEdit) {
        await dispatch(
          updateCharity({ id: charityData._id, data: formData })
        ).unwrap();
      } else {
        await dispatch(createCharity(formData)).unwrap();
      }
      onClose();
    } catch (err) {
      console.error("❌ Error saving charity:", err);
    }
  };

  const handleFieldChange = async (key, value) => {
    try {
      const res = await dispatch(uploadImage(value));
      setFormData((prev) => ({
        ...prev,
        [key]: res.payload.fileURL,
      }));
    } catch (e) {
      console.log(e, "error");
    }
  };

  return (
    <RootWrapperModalAdminpayments>
      <Overlay>
        <Wrapper>
          <StatusUpdate>
            <Left>
              <Frame58>
                {/* Header */}
                <Frame1391>
                  <Frame1527>
                    <Frame1527_0001>
                      <AddPayment>
                        {isEdit ? "Update Charity" : "Add Charity"}
                      </AddPayment>
                    </Frame1527_0001>
                  </Frame1527>
                </Frame1391>

                {/* Form */}
                <Frame1391>
                  <PRTNR.Input
                    label="Charity Title"
                    value={formData.name}
                    onChange={(e) => {
                      setFormData({ ...formData, name: e.target.value });
                    }}
                    required
                    error={hasSubmitted && !formData.name}
                    errorMessage="Required Field"
                  />
                  <PRTNR.Input
                    label="Number"
                    value={formData.number}
                    onChange={(e) => {
                      setFormData({ ...formData, number: e.target.value });
                    }}
                    required
                    error={hasSubmitted && !formData.number}
                    errorMessage="Required Field"
                  />

                  <PRTNR.FileInput
                    label="Upload logo"
                    helpText="JPG, GIF or PNG. Max file size 800kb"
                    accept=".jpg,.jpeg,.gif,.png"
                    onChange={(e) => {
                      if (e) {
                        handleFieldChange("logo", e);
                      } else {
                        console.log("No file selected");
                      }
                    }}
                    name="logo"
                    value={formData.logo}
                  />

                  <PRTNR.TextArea
                    label="Short Description"
                    value={formData.short_description}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        short_description: e.target.value,
                      });
                    }}
                  />
                  <PRTNR.TextArea
                    label="Long Description"
                    value={formData.long_description}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        long_description: e.target.value,
                      });
                    }}
                  />

                  <ContactDetails>Contact Details</ContactDetails>

                  <PRTNR.Input
                    label="Contact Number"
                    value={formData.contact_number}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        contact_number: e.target.value,
                      });
                    }}
                    required
                    error={hasSubmitted && !formData.contact_number}
                    errorMessage="Required Field"
                  />
                  <PRTNR.Input
                    label="Person to contact"
                    value={formData.person_to_contact}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        person_to_contact: e.target.value,
                      });
                    }}
                  />
                  <PRTNR.Input
                    label="Address"
                    value={formData.address}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        address: e.target.value,
                      });
                    }}
                  />
                  <PRTNR.Input
                    label="Postal Code"
                    value={formData.postal_code}
                    onChange={(e) => {
                      setFormData({
                        ...formData,
                        postal_code: e.target.value,
                      });
                    }}
                  />
                </Frame1391>

                {/* Buttons */}
                <Frame59>
                  <AIMEButton
                    size="small"
                    onClick={onClose}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      borderRadius: "999px",
                      background: "rgb(241, 245, 249)",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "rgb(33, 37, 67)",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      Discard
                    </span>
                  </AIMEButton>

                  <AIMEButton
                    size="small"
                    onClick={() => {
                      handler();
                    }}
                    sx={{
                      display: "flex",
                      justifyContent: "center",
                      flexDirection: "row",
                      alignItems: "center",
                      gap: "10px",
                      borderRadius: "48px",
                      width: "240px",
                      background: "rgb(97, 98, 197)",
                      padding: "16px 32px",
                    }}
                  >
                    <span
                      style={{
                        color: "white",
                        fontSize: "16px",
                        fontWeight: "600",
                      }}
                    >
                      {isEdit ? "Update" : "Save"}
                    </span>
                  </AIMEButton>
                </Frame59>
              </Frame58>
            </Left>
          </StatusUpdate>
        </Wrapper>
      </Overlay>
    </RootWrapperModalAdminpayments>
  );
}

const RootWrapperModalAdminpayments = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  box-sizing: border-box;
`;

const Overlay = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Wrapper = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: none;
  box-sizing: border-box;
  padding: 40px 24px 24px;
`;


const StatusUpdate = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: flex-start;
  flex: none;
  gap: 24px;
  width: 610px;
  box-sizing: border-box;
`;

const Left = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  flex: 1;
  gap: 8px;
  width: 610px;
  box-sizing: border-box;
`;

const Frame58 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1391 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;

const Frame1527 = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  align-items: center;
  align-self: stretch;
  flex-shrink: 0;
`;

const Frame1527_0001 = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  width: 610px;
  box-sizing: border-box;
`;

const AddPayment = styled.span`
  color: rgb(33, 37, 67);
  text-overflow: ellipsis;
  font-size: 30px;
  font-family: Montserrat, sans-serif;
  font-weight: 700;
  text-align: left;
  width: 612px;
  flex: 1;
`;
const ContactDetails = styled.span`
  color: var(--Color-Text-Text, #212543);
  font-family: Montserrat;
  font-size: var(--Fonts-P1, 20px);
  font-style: normal;
  font-weight: 700;
  line-height: 160%;
  flex: 1 0 0;
`;

const Frame59 = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: row;
  align-items: flex-start;
  align-self: stretch;
  box-sizing: border-box;
  flex-shrink: 0;
`;
